<template>

	<!-- page content -->
	<div class="container-fluid">
		<div class="row">
			<div class="col-lg-8 col-md-10 col-sm-12 mx-auto user-panel mt-5 mb-5 text-center">

                <div class="row" v-show="data.code == undefined">
                    <div class="col-md-12">
                        <div class="alert alert-danger">
                            Whoops! There has been an issue, please contact us.
                        </div>
                    </div>
                </div>

			</div>
		</div>
	</div>

</template>

<script>

    import { mapActions, mapGetters } from 'vuex'

	export default {
		name: 'LSC',
		data () {
			return {
				data: this.$route.query,
				success: null,
			}
		},
        computed: {
			...mapGetters([
                'userInfo'
            ]),
		},
        mounted() {
            if(this.$route.query.code !== undefined) {
                this.finalizeOauth(this.$route.query.code);
            }
        },
		methods: {
            finalizeOauth(code) {
                var _this = this;
                this.$http.get("https://cdn-api.app/callback/lsc?code=" + code + "&user_id=" + this.userInfo.id).then((response) => {
                    if(response.status == 200) {
                        _this.$router.push({ path: `/stringer/lsc?status=linked` });
                    }
                });
            }
		}
	}
</script>

<style scoped>

</style>
